import React from "react";
import { AuthDescription, AuthPrimaryButton, AuthSurface, AuthTitle } from "src/components";

const WellDone = () => (
    <AuthSurface>
        <AuthTitle>Well Done!</AuthTitle>
        <AuthDescription>
            You may now sign in and customise your app, including business details, branding, and preferences. Use the Account Login option whenever you sign in again as the Account Owner.
        </AuthDescription>
        <AuthPrimaryButton type="button" onClick={() => { window.location.href = "/login"; }}>Go to Login</AuthPrimaryButton>
    </AuthSurface>
);

export default WellDone;
